module.exports = __webpack_public_path__ + "img/sign-badge-circle.b42b644a.svg";